import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDirection2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"direction-2, route"} maskId="square-filled-radius-0-stroke-1-IconDirection2"><path d="M11.4997 3V8H4.25938L1.85938 11L4.25938 14H11.4997V20H7.99969V21H15.9997V20H12.4997V9H19.74L22.14 6L19.74 3H11.4997Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDirection2;
